import { render, staticRenderFns } from "./search-icon.vue?vue&type=template&id=c0fad692&scoped=true&lang=pug&"
import script from "./search-icon.vue?vue&type=script&lang=js&"
export * from "./search-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0fad692",
  null
  
)

export default component.exports